import { PodiumEntry } from "../data/Types";

interface PodiumProps {
  entries: PodiumEntry[];
}

export default function Podium({ entries }: PodiumProps) {
  return (
    <>
      <div className="gap-10 flex flex-row justify-center">
        <div className="w-1/4">
          <h3 className="text-center text-4xl">#1</h3>
        </div>
        <div className="w-1/4">
          <h3 className="text-center text-4xl">#2</h3>
        </div>
        <div className="w-1/4">
          <h3 className="text-center text-4xl">#3</h3>
        </div>
      </div>
      <div className="gap-10 flex flex-row justify-center">
        <div className="flex flex-col justify-center w-1/4">
          <img src={entries[0].imgPath} alt={entries[0].name} />
          <div></div>
        </div>
        <div className="flex flex-col justify-center w-1/4">
          <img
            className="justify-self-center"
            src={entries[1].imgPath}
            alt={entries[1].name}
          />
        </div>
        <div className="flex flex-col justify-center w-1/4">
          <img src={entries[2].imgPath} alt={entries[2].name} />
          <div></div>
        </div>
      </div>
    </>
  );
}
